// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"99":"ddea5636","118":"e81c57f8","389":"202ef3c7","818":"c586d964"}[chunkId] + ".chunk.js");